<template>
    <div>
        <b-row>
            <!-- What's your question? -->
            <b-col md="12">
                <b-form-group>
                    <label for="yourQuestion">
                        <h6><strong>What's your question?</strong></h6>
                    </label>
                    <b-form-input type="text" name="yourQuestion" v-model="prop_siteSettingArray.yourQuestion" />
                </b-form-group>
            </b-col>

            <!-- First Answer -->
            <b-col md="12">
                <b-form-group>
                    <label for="firstAnswer">
                        <h6><strong>First Answer</strong></h6>
                    </label>
                    <b-form-input type="text" name="firstAnswer" v-model="prop_siteSettingArray.firstAnswer" />
                </b-form-group>
            </b-col>

            <!-- Second Answer -->
            <b-col md="12">
                <b-form-group>
                    <label for="secondAnswer">
                        <h6><strong>Second Answer</strong></h6>
                    </label>
                    <b-form-input type="text" name="secondAnswer" v-model="prop_siteSettingArray.secondAnswer" />
                </b-form-group>
            </b-col>

            <!-- Enter link URL for second answer -->
            <b-col md="12">
                <b-form-group>
                    <label for="secondButtonURL">
                        <h6><strong>Enter link URL for second answer</strong></h6>
                    </label>
                    <b-form-input type="text" name="secondButtonURL" v-model="prop_siteSettingArray.secondButtonURL" placeholder="http://example.com" />
                </b-form-group>
            </b-col>

            <!-- Font family -->
            <b-col md="12">
                <b-form-group>
                    <label for="questionFontFamily">
                        <h6><strong>Font family</strong></h6>
                    </label>
                    <Select2 :options="questionFontFamily" name="questionFontFamily" v-model="prop_siteSettingArray.questionFontFamily" />
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import { BRow, BCol, BFormInput, BFormGroup, BInputGroup } from 'bootstrap-vue'
    import captureOptions from "@/libs/capture-Options"

    export default {
        components: {
            BRow, BCol, BFormInput, BFormGroup, BInputGroup
        },
        props: {
            prop_siteSettingArray: {
                type: Object,
                default: () => { },
            }
        },
        computed: {
        },
        created() {
            if (_.isEmpty(this.prop_siteSettingArray.yourQuestion)) {
                this.prop_siteSettingArray.yourQuestion = 'First time here?';
            }
            if (_.isEmpty(this.prop_siteSettingArray.firstAnswer)) {
                this.prop_siteSettingArray.firstAnswer = 'Yes'
            }
            if (_.isEmpty(this.prop_siteSettingArray.secondAnswer)) {
                this.prop_siteSettingArray.secondAnswer = 'No';
            }
            if (_.isEmpty(this.prop_siteSettingArray.questionFontFamily)) {
                this.prop_siteSettingArray.questionFontFamily = 'Open Sans';
            }
        },
        setup() {
            const { questionFontFamily } = captureOptions();
            return {
                questionFontFamily
            }
        },
    }
</script>